import React, { useEffect, useRef } from 'react';
import { Card, Button, CloseButton } from '../design-system';
import { Award } from 'lucide-react';

const TaskCompletionCelebration = ({ isOpen, onClose, message = "You're committed to your healing", onViewCards }) => {
  const audioRef = useRef(null);

  // Play celebration audio when modal opens
  useEffect(() => {
    if (isOpen) {
      // Create and play audio
      const audio = new Audio('/audio/celebration.wav');
      audioRef.current = audio;
      
      // Play audio (with error handling for autoplay restrictions)
      audio.play().catch(error => {
        console.log('Audio playback failed:', error);
        // Some browsers may block autoplay, but that's okay
      });

      // Cleanup audio when component unmounts or closes
      return () => {
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
          audioRef.current = null;
        }
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[60] p-4 animate-fadeIn">
      <Card 
        variant="elevated" 
        padding="large" 
        className="max-w-md w-full text-center animate-slideUp"
        style={{ backgroundColor: '#fbeede' }}
      >
        <div className="flex flex-col items-center space-y-6">
          {/* Close Button */}
          <div className="self-end">
            <CloseButton
              onClick={onClose}
              className="p-2 text-gray-400 hover:text-gray-600"
            />
          </div>

          {/* Mascot Video or GIF */}
          <div className="flex justify-center w-full">
            <img 
              src="/images/mascot/celebration.gif" 
              alt="TheraEngage Mascot Celebration" 
              className="w-full h-auto"
            />
          </div>

          {/* Celebration Message */}
          <div className="space-y-3">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
              Congrats!
            </h2>
            <p className="text-lg md:text-xl text-gray-700 font-medium">
              {message}
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 w-full">
            {onViewCards && (
              <Button
                variant="outline"
                size="medium"
                onClick={() => {
                  onClose();
                  onViewCards();
                }}
                className="w-full sm:w-auto px-8 flex items-center justify-center gap-2"
              >
                <Award className="h-4 w-4" />
                View Collection
              </Button>
            )}
            <Button
              variant="primary"
              size="medium"
              onClick={onClose}
              className="w-full sm:w-auto px-8"
            >
              Continue
            </Button>
          </div>
        </div>
      </Card>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideUp {
          from {
            transform: translateY(20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }

        .animate-slideUp {
          animation: slideUp 0.4s ease-out;
        }
      `}</style>
    </div>
  );
};

export default TaskCompletionCelebration;

